import { Graph } from '@antv/g6';

/**
 * Download the part of the graph you can currently see on the screen
 */
export const downloadImage = (graph: Graph) => graph?.downloadImage();

/**
 * Download the entire graph - including the parts not currently visible
 */
export const downloadFullImage = (graph: Graph) => graph?.downloadFullImage();
